import moment from "moment";
export class periodosOperativo{
  static obtenerPeriodos(fecha){

    const fechaIn = moment(fecha).subtract(5, 'years').add(1, 'months');

    let fechaPer, aniosDisponibles = [];
    for(var i = 0; i <= fecha.diff(fechaIn, 'month'); i++){
      fechaPer = moment(fechaIn).add(i, 'months');
      const mes = moment(fechaPer).month()+1; 
      const anio = ''+moment(fechaPer).year();

      const existeAn = aniosDisponibles.filter( an => an.anio === anio);
      if(existeAn.length === 0){
        aniosDisponibles.push({anio: anio, series: [], visible: anio})
        aniosDisponibles[aniosDisponibles.length-1].series.push({
          periodo: FuncionesMes.getMesesN(mes) + '-' + anio.substring(2,4),
          mes: FuncionesMes.getMesesN(mes),
          an: Number(anio),
          anio: anio.substring(2,4),
          check: false,
          visible: true,
        });
      }else{
        aniosDisponibles[aniosDisponibles.length-1].series.push({
          periodo: FuncionesMes.getMesesN(mes) + '-' + anio.substring(2,4),
          mes: FuncionesMes.getMesesN(mes),
          an: Number(anio),
          anio: anio.substring(2,4),
          check: false,
          visible: true,
        });
      }
    }

    aniosDisponibles[aniosDisponibles.length-1].series[aniosDisponibles[aniosDisponibles.length-1].series.length-1].check = true;
    return aniosDisponibles;
  }
  static obtenerPeriodosFechas(fecha, fechaIn){

    // const fechaIn = moment(fecha).subtract(5, 'years').add(1, 'months');

    let fechaPer, aniosDisponibles = [];
    for(var i = 0; i <= fecha.diff(fechaIn, 'month'); i++){
      fechaPer = moment(fechaIn).add(i, 'months');
      const mes = moment(fechaPer).month()+1; 
      const anio = ''+moment(fechaPer).year();

      const existeAn = aniosDisponibles.filter( an => an.anio === anio);
      if(existeAn.length === 0){
        aniosDisponibles.push({anio: anio, series: [], visible: anio})
        aniosDisponibles[aniosDisponibles.length-1].series.push({
          periodo: FuncionesMes.getMesesN(mes) + '-' + anio.substring(2,4),
          mes: FuncionesMes.getMesesN(mes),
          an: Number(anio),
          anio: anio.substring(2,4),
          check: false,
          visible: true,
        });
      }else{
        aniosDisponibles[aniosDisponibles.length-1].series.push({
          periodo: FuncionesMes.getMesesN(mes) + '-' + anio.substring(2,4),
          mes: FuncionesMes.getMesesN(mes),
          an: Number(anio),
          anio: anio.substring(2,4),
          check: false,
          visible: true,
        });
      }
    }

    aniosDisponibles[aniosDisponibles.length-1].series[aniosDisponibles[aniosDisponibles.length-1].series.length-1].check = true;
    return aniosDisponibles;
  }
  static validacionPeriodo(fecha, fechaIni, fechaFin){
    const dif1 = fecha.diff(fechaIni, 'month');
    const dif2 = fechaFin.diff(fecha, 'month');
    if(dif1 > 0 && dif2 > 0){
      return true;
    }
    if( dif1 === 0 && moment(fecha).month() >= moment(fechaIni).month() ){
      return true;
    }
    if( dif2 === 0 && moment(fecha).month() <= moment(fechaFin).month() ){
      return true;
    }
    return false;
  }
}
export class FuncionesMes{
  static f_switchmes(mes){
      switch(mes){
          case '01': mes = 'enero';break;
          case '02': mes = 'febrero';break;
          case '03': mes = 'marzo';break;
          case '04': mes = 'abril';break;
          case '05': mes = 'mayo';break;
          case '06': mes = 'junio';break;
          case '07': mes = 'julio';break;
          case '08': mes = 'agosto';break;
          case '09': mes = 'septiembre';break;
          case '10': mes = 'octubre';break;
          case '11': mes = 'noviembre';break;
          case '12': mes = 'diciembre';break;
      }
      return mes;
  }
  static f_switchmes2(mes){
      switch(mes){
          case '01': mes = 'ene';break;
          case '02': mes = 'feb';break;
          case '03': mes = 'mar';break;
          case '04': mes = 'abr';break;
          case '05': mes = 'may';break;
          case '06': mes = 'jun';break;
          case '07': mes = 'jul';break;
          case '08': mes = 'ago';break;
          case '09': mes = 'sep';break;
          case '10': mes = 'oct';break;
          case '11': mes = 'nov';break;
          case '12': mes = 'dic';break;
      }
      return mes;
  }
  public static f_switchmes3(mes){
      switch(mes){
          case 'ene': mes = '01';break;
          case 'feb': mes = '02';break;
          case 'mar': mes = '03';break;
          case 'abr': mes = '04';break;
          case 'may': mes = '05';break;
          case 'jun': mes = '06';break;
          case 'jul': mes = '07';break;
          case 'ago': mes = '08';break;
          case 'sep': mes = '09';break;
          case 'oct': mes = '10';break;
          case 'nov': mes = '11';break;
          case 'dic': mes = '12';break;
      }
      return mes;
  }
  static f_switchmesi(mes){
      switch(mes){
          case 'ENERO': mes = '01';break;
          case 'FEBRERO': mes = '02';break;
          case 'MARZO': mes = '03';break;
          case 'ABRIL': mes = '04';break;
          case 'MAYO': mes = '05';break;
          case 'JUNIO': mes = '06';break;
          case 'JULIO': mes = '07';break;
          case 'AGOSTO': mes = '08';break;
          case 'SEPTIEMBRE': mes = '09';break;
          case 'OCTUBRE': mes = '10';break;
          case 'NOVIEMBRE': mes = '11';break;
          case 'DICIEMBRE': mes = '12';break;
      }
      return mes;
  }
  static obteneranios(arreglo){
      var cadena = "";
      for(var i = 0; i < arreglo.length; i++){
          if(i == 0){
              cadena = arreglo[i].name;
          }else{
              cadena = cadena + " . " + arreglo[i].name;
          }
      }
      return cadena;
  }
  static getMesesN(mes: any){
    switch (mes){
      case 1: return 'ene';
      case 2: return 'feb';
      case 3: return 'mar';
      case 4: return 'abr';
      case 5: return 'may';
      case 6: return 'jun';
      case 7: return 'jul';
      case 8: return 'ago';
      case 9: return 'sep';
      case 10: return 'oct';
      case 11: return 'nov';
      case 12: return 'dic';
    }
    return mes;
  }
  static obtenerPeriodosFull(fecha_inicial: Date, fecha_final: Date){
    var aniosDisponibles: any = [];
    var messin = 0, messfinal;
    aniosDisponibles = [];
    const fech = new Date();
    const perAct = this.getMesesN(fech.getMonth()+1)+'-'+fech.getFullYear().toString().substring(2,4);
    for(var i = fecha_inicial.getFullYear(); i<=fecha_final.getFullYear(); i++){
      if(i === fecha_inicial.getFullYear() && i != fecha_final.getFullYear()){
        messin = fecha_inicial.getMonth();
        messfinal = 11;
      }else if(i === fecha_final.getFullYear() && i != fecha_inicial.getFullYear()){
        messin = 0;
        messfinal = fecha_final.getMonth();
      }else if( i != fecha_inicial.getFullYear() && i != fecha_final.getFullYear() ){
        messin = 0;
        messfinal = 11;
      }else{
        messin = fecha_inicial.getMonth();
        messfinal = fecha_final.getMonth();
      }
      var anio = ''+i;
      aniosDisponibles.push({anio: i, series: []})
      for(var j = messin; j <= messfinal; j++){
        aniosDisponibles[i-fecha_inicial.getFullYear()].series.push({
          periodo: this.getMesesN(j+1) + '-' + anio.substring(2,4),
          mes: this.getMesesN(j+1),
          check: false,
        });
      }
    }
    aniosDisponibles[aniosDisponibles.length-1].series[aniosDisponibles[aniosDisponibles.length-1].series.length-1].check = true;
    return aniosDisponibles;
  }
  static escrituraPer(periodo){
    var mes = periodo.split(' ')[0];
    var an = periodo.split(' ')[1];
    mes = this.getMesesNum(mes);
    return mes+'/01/'+an;
  }
  static getMesesNum(mes: any){
    switch (mes){
      case 'ene': return '01';
      case 'feb': return '02';
      case 'mar': return '03';
      case 'abr': return '04';
      case 'may': return '05';
      case 'jun': return '06';
      case 'jul': return '07';
      case 'ago': return '08';
      case 'sep': return '09';
      case 'oct': return '10';
      case 'nov': return '11';
      case 'dic': return '12';
    }
    return mes;
  }
}

export class periodos{
  static obtenerPeriodos(arreglo, numEvaluaciones){
    arreglo.sort(function (a, b) {
      if (a.fechaContable.substring(0,7) > b.fechaContable.substring(0,7)) {
        return 1;
      }
      if (a.fechaContable.substring(0,7) < b.fechaContable.substring(0,7)) {
        return -1;
      }
      return 0;
    });
    
    var aux = [], auxanio = [], i = 0;
    let periodosSeleccionados = 0;
    for(const data of arreglo){
      const date = new Date( data.fechaContable.substring(5,7) +'/'+ data.fechaContable.substring(8,10) +'/'+ data.fechaContable.substring(0,4) );
      const exist = auxanio.filter(an => an.anio === date.getFullYear());
      if(exist.length===0){
        auxanio.push({
          anio: date.getFullYear(),
          series: [],
          visible: true,
          utilizable: true,
        });
      }
      var check = false;
      if(i >= arreglo.length-numEvaluaciones){
        periodosSeleccionados++;
        check = true;
      }
      aux.push({
        mes: FuncionesMes.f_switchmes2( date.getMonth()<9?'0'+(date.getMonth()+1):''+(date.getMonth()+1) ),
        check: check,
        id: data.id,
        an: date.getFullYear(),
        anio: (''+date.getFullYear()).substring(2,4),
        periodo: FuncionesMes.f_switchmes2( date.getMonth()<9?'0'+(date.getMonth()+1):''+(date.getMonth()+1) ) + ' ' + (''+date.getFullYear()).substring(2,4),
        visible: true,
        utilizable: true,
      });
      i++;
    }
    for(const an of auxanio){
      const meses = aux.filter(mes => mes.an === an.anio);
      if(meses.length!==0){
        an.series = meses;
      }
    }
    return { periodos: auxanio, perSel : periodosSeleccionados};
  }
  static obtenerPeriodosFormulador(arreglo){
    moment.locale('es');

    let Periodos = [];
    let periodoSeleccionado;

    arreglo.forEach(periodo => {

      const fecha = moment(periodo.fechaContable);

      let periodoAnio = Periodos.find(p => p.anio === fecha.year());

      if (!periodoAnio) {
        periodoAnio = {
          anio: fecha.year(),
          visible: true,
          series: []
        };

        Periodos.push(periodoAnio);
      }

      periodoAnio.series.push({
        id: periodo.id,
        idInstitucion: periodo.idInstitucion,
        idPlantilla: periodo.idPlantilla,
        fechaContable: periodo.fechaContable,

        mes: fecha.format('MMM').replace('.','').toLowerCase(),
        anio: fecha.format('YY'),
        visible: true,
        check: false,
        nombre: fecha.format('MMM YY').replace('.','').toLowerCase()
      });
    });

    Periodos.sort((a, b) => a.anio - b.anio);
    Periodos.forEach(periodo => {
      periodo.series.sort((a, b) =>
        moment(a.fechaContable).diff(moment(b.fechaContable))
      );
    });

    // Quita cualquier selección anterior
    Periodos.forEach(periodo =>
      periodo.series.forEach(serie => serie.check = false)
    );

    // Selecciona el último año y el último mes
    const ultimoAnio = Periodos[Periodos.length - 1];

    if (ultimoAnio) {
      periodoSeleccionado = ultimoAnio.series[ultimoAnio.series.length - 1];
      periodoSeleccionado.check = true;
    }
    return {periodos: Periodos, perSeleccionado: periodoSeleccionado};
  }
}
export class formatear{
  static periodosRC(data){
    data.sort( function (a, b) {
      if (a['Periodo'] > b['Periodo']) {
        return 1;
      }
      if (a['Periodo'] < b['Periodo']) {
        return -1;
      }
      return 0;
    });
    var anios = [], meses = [];
    for(const per of data){
      const date = moment(per['Periodo'], 'YYYYMM');
      var anio = date.year();
      var mes = date.format('MMM').toLocaleLowerCase();
      var anioMes = date.format('YYYYMM')

      if(!anios.some(a => a.value === anio)){
        anios.push({
          name: anio.toString(), 
          value: anio, 
          check: false, 
          selected: false})
      }
      meses.push({
        name: mes,
        value: anioMes.toString(),
        year: anio.toString(), 
        check: false
      })
    }
    var periodos = {
      aniosDisponibles: anios,
      mesesDisponibles: meses
    }
    return periodos;
  }
  static capitalizar(texto: string): string{
    return texto ? texto.toLowerCase().replace(/(^|\s)\S/g, letra => letra.toUpperCase()) : texto;
  }
  static momentAbrev(){
    moment.updateLocale('es', {
      monthsShort: [
        'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
        'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
      ],
      months:[
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ]
    });
  }
  static retornarformatolefty(valor): string{
      if (valor >= 1000000000000){
          valor =  (valor / 1000000000).toFixed(2) + ' Billón -';
      }else if (valor >= 1000000000){
          valor =  (valor / 1000000000).toFixed(2) + ' Mil_M -';
      }else if (valor >= 1000000){
          valor =  (valor / 1000000).toFixed(2) + ' M -';
      }else if (valor >= 1000){
          valor =  (valor / 1000).toFixed(2) + ' Mil -';
      }
      return ''+valor;
  }
  static retornarformatoval(valor, suf, guion, miles, decimal): string{
      if(valor%1!==0){
          if (suf==='Billón'){
              return  this.formatearMoneda(valor * 1000000000,true, miles, decimal);
          }else if (suf==='Mil_M'){
              return  this.formatearMoneda(valor * 1000000000,true, miles, decimal);
          }else if (suf==='M'){
              return  this.formatearMoneda(valor * 1000000,true, miles, decimal);
          }else if (suf==='Mil'){
              return this.formatearMoneda(valor * 1000,true, miles, decimal);
          }
      }
      if(suf !== undefined){
          return ''+valor +' '+ suf +' '+ guion;
      }
      return ''+valor;
  }
  static formatoNum(num, dec){
    let n = ''+num;
    if(n.includes('.') && n.split('.').length===1){
      return this.formatear(num, false)+'.'
    }else if(n.includes('.') && n.split('.').length===2 && n.split('.')[1] === ''){
      return this.formatear(num, false)+'.'
    }else if(n.includes('.') && n.split('.').length===2){
      num = n.split('.')[0]+'.'+n.split('.')[1][0];
    }else if(n.includes('.') && n.split('.').length>2){
      num = n.split('.')[0]+'.'+n.split('.')[1];
    }
    //no se requieren decimales
    if(!n.includes('.')){
      return this.formatear(num, false);
    }
    if(!dec){num = Number(num.toFixed(0));} 
    if (num !== undefined && num !== ''){
      return this.formatear(num, dec);
    }
    return '';
  }

  static formatear(num, dec){
    var separador =  ",";
    var sepDecimal = '.';
    num +='';
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, '$1' + separador + '$2');
    }
    if(splitRight == "" && dec){
        splitRight = ".0";
    }
    if(!dec){
        splitRight = "";
    }
    return  splitLeft + splitRight;
  }
  static formatearMoneda(num, dec, separadorM, separadorD){
    var separador =  separadorM;
    var sepDecimal = separadorD;
    num +='';
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, '$1' + separador + '$2');
    }
    if(splitRight == "" && dec){
        splitRight = `${sepDecimal}0`;
    }
    if(!dec){
        splitRight = "";
    }
    return  splitLeft + splitRight;
  }
  static removeAccents = (str: any) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
}
export class colors{
  static colors(graf){
    const idsBal = {
      'pie': ['#2843A0','#15A075','#36CAE8','#78EAD2','#F88476','#E23E6A'],
      'line': ['#2843A0'],
      'bar': ['#2843A0','#15A075','#36CAE8','#78EAD2','#F88476','#E23E6A'],
      'line2': ['#2843A0','#15A075','#36CAE8','#78EAD2','#F88476','#E23E6A'],
      'rad': ['#2843A0','#15A075','#36CAE8','#78EAD2','#F88476','#E23E6A'],
      'point': ['#2843A0','#15A075','#36CAE8','#78EAD2','#F88476','#E23E6A'],
      'point2': ['#6A94CA','#5228A9'],
    }
    return idsBal[graf] ?? undefined;
  }
}

// FUNCIONES GENERALES RIESGO DE CREDITO WEB-SERVICIES
export class CommonVariables {
  static get MesesArr() { return ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']; }

  static get MesesJson() { return [
      { mes: 'ene', value: 1 },
      { mes: 'feb', value: 2 },
      { mes: 'mar', value: 3 },
      { mes: 'abr', value: 4 },
      { mes: 'may', value: 5 },
      { mes: 'jun', value: 6 },
      { mes: 'jul', value: 7 },
      { mes: 'ago', value: 8 },
      { mes: 'sep', value: 9 },
      { mes: 'oct', value: 10 },
      { mes: 'nov', value: 11 },
      { mes: 'dic', value: 12 },
  ]; }
  static f_switchmes(mes){
      switch(mes){
          case '01': mes = 'ENERO';break;
          case '02': mes = 'FEBRERO';break;
          case '03': mes = 'MARZO';break;
          case '04': mes = 'ABRIL';break;
          case '05': mes = 'MAYO';break;
          case '06': mes = 'JUNIO';break;
          case '07': mes = 'JULIO';break;
          case '08': mes = 'AGOSTO';break;
          case '09': mes = 'SEPTIEMBRE';break;
          case '10': mes = 'OCTUBRE';break;
          case '11': mes = 'NOVIEMBRE';break;
          case '12': mes = 'DICIEMBRE';break;
      }
      return mes;
  }
  static f_switchmesA(mes){
      switch(mes){
          case '01': mes = 'Enero';break;
          case '02': mes = 'Febrero';break;
          case '03': mes = 'Marzo';break;
          case '04': mes = 'Abril';break;
          case '05': mes = 'Mayo';break;
          case '06': mes = 'Junio';break;
          case '07': mes = 'Julio';break;
          case '08': mes = 'Agosto';break;
          case '09': mes = 'Septiembre';break;
          case '10': mes = 'Octubre';break;
          case '11': mes = 'Noviembre';break;
          case '12': mes = 'Diciembre';break;
      }
      return mes;
  }
  static f_switchmesm(mes){
      switch(mes){
          case '01': mes = 'ene';break;
          case '02': mes = 'feb';break;
          case '03': mes = 'mar';break;
          case '04': mes = 'abr';break;
          case '05': mes = 'may';break;
          case '06': mes = 'jun';break;
          case '07': mes = 'jul';break;
          case '08': mes = 'ago';break;
          case '09': mes = 'sep';break;
          case '10': mes = 'oct';break;
          case '11': mes = 'nov';break;
          case '12': mes = 'dic';break;
      }
      return mes;
  }
  static f_switchmesEntero(mes){
      switch(mes){
          case '1': mes = 'ene';break;
          case '2': mes = 'feb';break;
          case '3': mes = 'mar';break;
          case '4': mes = 'abr';break;
          case '5': mes = 'may';break;
          case '6': mes = 'jun';break;
          case '7': mes = 'jul';break;
          case '8': mes = 'ago';break;
          case '9': mes = 'sep';break;
          case '10': mes = 'oct';break;
          case '11': mes = 'nov';break;
          case '12': mes = 'dic';break;
      }
      return mes;
  }
  static f_switchmesNumerico(mes){
      switch(mes){
          case 'ene': mes = '1';break;
          case 'feb': mes = '2';break;
          case 'mar': mes = '3';break;
          case 'abr': mes = '4';break;
          case 'may': mes = '5';break;
          case 'jun': mes = '6';break;
          case 'jul': mes = '7';break;
          case 'ago': mes = '8';break;
          case 'sep': mes = '9';break;
          case 'oct': mes = '10';break;
          case 'nov': mes = '11';break;
          case 'dic': mes = '12';break;
      }
      return mes;
  }
  static formatear(num){
      var separador =  ","; // separador para los miles
      var sepDecimal = '.';
      num +='';
      var splitStr = num.split('.');
      var splitLeft = splitStr[0];
      var splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : '';
      var regx = /(\d+)(\d{3})/;
      while (regx.test(splitLeft)) {
        splitLeft = splitLeft.replace(regx, '$1' + separador + '$2');
      }
      /*if(splitRight == ""){
          splitRight = ".00";
      }*/
      return  splitLeft + splitRight;
    }
  static porcentaje(arreglo,dato){
      var suma = 0;
      for(var i = 0; i < arreglo.length; i++){
          if(dato.name == arreglo[i].name){
              suma = arreglo[i].value;
          }
      }
      return ((dato.value*100)/suma);
  }
  static porcentajec(arreglo,item_tabla,dato){
      var suma = 0;
      for(var i = 0; i < arreglo.length; i++){
          if(item_tabla == arreglo[i].name){
              for(var j = 0; j < arreglo[i].series.length; j ++){
                  suma = suma + arreglo[i].series[j].value;
              }
          }
      }
      return ((dato.value*100)/suma);
  }
  static removeAccents = (str: any) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  static formatearMoneda(num, dec, separadorM, separadorD){
    var separador =  separadorM;
    var sepDecimal = separadorD;
    num +='';
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, '$1' + separador + '$2');
    }
    if(splitRight == "" && dec){
        splitRight = ".0";
    }
    if(!dec){
        splitRight = "";
    }
    return  splitLeft + splitRight;
  }
    static obtenerPeriodos(arreglo, numEvaluaciones){
    arreglo.sort(function (a, b) {
      if (a.fechaContable.substring(0,7) > b.fechaContable.substring(0,7)) {
        return 1;
      }
      if (a.fechaContable.substring(0,7) < b.fechaContable.substring(0,7)) {
        return -1;
      }
      return 0;
    });
    
    var aux = [], auxanio = [], i = 0;
    let periodosSeleccionados = 0;
    for(const data of arreglo){
      const date = new Date( data.fechaContable.substring(5,7) +'/'+ data.fechaContable.substring(8,10) +'/'+ data.fechaContable.substring(0,4) );
      const exist = auxanio.filter(an => an.anio === date.getFullYear());
      if(exist.length===0){
        auxanio.push({
          anio: date.getFullYear(),
          series: [],
          visible: true,
          utilizable: true,
        });
      }
      var check = false;
      if(i >= arreglo.length-numEvaluaciones){
        periodosSeleccionados++;
        check = true;
      }
      aux.push({
        mes: FuncionesMes.f_switchmes2( date.getMonth()<9?'0'+(date.getMonth()+1):''+(date.getMonth()+1) ),
        nmes: data.month??date.getMonth()+1,
        check: check,
        id: data.id,
        an: date.getFullYear(),
        anio: (''+date.getFullYear()).substring(2,4),
        periodo: FuncionesMes.f_switchmes2( date.getMonth()<9?'0'+(date.getMonth()+1):''+(date.getMonth()+1) ) + ' ' + (''+date.getFullYear()).substring(2,4),
        visible: true,
        utilizable: true,
      });
      i++;
    }
    for(const an of auxanio){
      const meses = aux.filter(mes => mes.an === an.anio);
      if(meses.length!==0){
        an.series = meses;
      }
    }
    return { periodos: auxanio, perSel : periodosSeleccionados};
  }  
}

export class FuncionesRiesgo{
  static separador: string = ","; // separador para los miles
  static sepDecimal: string = '.'; // separador para los decimales
  static formatearnormal(num) {
    if(num === null){
      return '0';
    }
      num += '';
      var splitStr = num.split('.');
      var splitLeft = splitStr[0];
      var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
      var regx = /(\d+)(\d{3})/;
      while (regx.test(splitLeft)) {
          splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
      }
      return splitLeft + splitRight;
  }
  static formatearnormalCredito(num) {
      num += '';
      var splitStr = num.split('.');
      var splitLeft = splitStr[0];
      var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
      var regx = /(\d+)(\d{3})/;
      while (regx.test(splitLeft)) {
          splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
      }
      return splitLeft + splitRight;
  }
}

export class ArraysOrder{
  static orderNumber(array, property){
    array.sort( function (a, b){
      if( Number(a[property]) > Number(b[property]) ){
        return 1
      }
      if( Number(a[property]) < Number(b[property])){
        return -1
      }
      return 0
    });
    return array;
  }
}

//FUNCIONES GENERALES DE RIESGO DE LIQUIDEZ
export class obtenerError{
  static errorObt(err: string){
    const map = {
      "Internal server error": "Ocurrio un error",
      undefined: "Ocurrio un error",
    };
    return map[err] ?? err+'';
  }
}
export class calculos{
  static operations(a,signo,b){
    const operaciones = {
      '+': (a, b) => a + b,
      '-': (a, b) => a - b,
      '*': (a, b) => a * b,
      '/': (a, b) => a / b,
    };

    if (!operaciones[signo]) {
      throw new Error(`Signo "${signo}" no soportado`);
    }

    return operaciones[signo](a, b);
  }
  static calculos(formula, variables){
    if(formula.includes('+') && formula.includes('/')){
      const form = formula.split(' + ');
      if(form.length === 2){
        const val1 = this.calculos(form[0], variables);
        const val2 = this.calculos(form[1], variables);
        return val1+val2;
      }      
    }
    const elements = formula.split(' ');
    if(elements.length < 2){
      const valor = variables.filter( valor => {
        return valor.id === elements[0];
      })[0];
      return valor?.valor ?? 0;
    }
    let val1=null, val2=null, signo = '';
    for(const elem of elements){
      if(val1===null){
        const valor = variables.filter( valor => valor.id === elem)[0];
        val1 = valor.valor;
      }else if(signo === ''){
        signo = elem;
      }else if(val2 === null){
        const valor = variables.filter( valor => valor.id === elem)[0];
        if(valor !== undefined){
          val2 = valor.valor;
        }
        switch(signo){
          case '/':
            val1 = isNaN(val1/val2) ? 0 : (val1/val2);
            signo = '';
            val2 = null;
            break;
          case '*':
            val1 = val1*val2;
            signo = '';
            val2 = null;
            break;
          case '+':
            val1 = val1+val2;
            signo = '';
            val2 = null;
            break;
          case '-':
            val1 = val1-val2;
            signo = '';
            val2 = null;
            break;
        }
      }
    }
    return Number(Number(val1).toFixed(2)); 
  }
  static calculosIndicadores(formula, variables){
    if(formula.includes('+') && formula.includes('/')){
      const form = formula.split(' + ');
      if(form.length === 2){
        const val1 = this.calculos(form[0], variables);
        const val2 = this.calculos(form[1], variables);
        return val1+val2;
      }      
    }
    const elements = formula.split(' ');
    if(elements.length < 2){
      const valor = variables[""+elements[0]];
      return valor;
    }
    let val1=null, val2=null, signo = '';
    for(const elem of elements){
      if(val1===null){
        const valor = variables[""+elem];
        val1 = valor;
      }else if(signo === ''){
        signo = elem;
      }else if(val2 === null){
        const valor = variables[""+elem];
        if(valor !== undefined){
          val2 = valor;
        }
        switch(signo){
          case '/':
            val1 = val1/val2;
            signo = '';
            val2 = null;
            break;
          case '*':
            val1 = val1*val2;
            signo = '';
            val2 = null;
            break;
          case '+':
            val1 = val1+val2;
            signo = '';
            val2 = null;
            break;
          case '-':
            val1 = val1-val2;
            signo = '';
            val2 = null;
            break;
        }
      }
    }
    return Number(val1.toFixed(1)); 
  }
  static calculosProm(formula, variables, pos){
    if(formula.includes('+') && formula.includes('/')){
      const form = formula.split(' + ');
      if(form.length === 2){
        const val1 = this.calculosProm(form[0], variables, pos);
        const val2 = this.calculosProm(form[1], variables, pos);
        return val1+val2;
      }      
    }
    const elements = formula.split(' ');
    if(elements.length < 2){
      const valor = variables.filter( valor => valor.id === elements[0])[0];
      return valor.valor[pos];
    }
    let val1=null, val2=null, signo = '';
    for(const elem of elements){
      if(val1===null){
        const valor = variables.filter( valor => valor.id === elem)[0];
        val1 = valor.valor[pos];
      }else if(signo === ''){
        signo = elem;
      }else if(val2 === null){
        const valor = variables.filter( valor => valor.id === elem)[0];
        if(valor !== undefined){
          val2 = valor.valor[pos];
        }
        switch(signo){
          case '/':
            val1 = isNaN(val1/val2) ? 0 : (val1/val2);
            signo = '';
            val2 = null;
            break;
          case '*':
            val1 = val1*val2;
            signo = '';
            val2 = null;
            break;
          case '+':
            val1 = val1+val2;
            signo = '';
            val2 = null;
            break;
          case '-':
            val1 = val1-val2;
            signo = '';
            val2 = null;
            break;
        }
      }
    }
    return Number(Number(val1).toFixed(2)); 
  }
}

